// Module
var code = `<a ng-click="showHideController.toggle()"> <expand-button is-open="showHideController.expanded"></expand-button> <span translate ng-if="!showHideController.expanded">Generic.ShowAll</span> <span translate ng-if="showHideController.expanded">Generic.Hide</span> </a> `;
// Exports
module.exports = code;